import { useEffect, useRef } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const track = (event, data = {}) => {
  axios.post(`${API}/track`, { event, ...data }).catch(() => {});
};

export const usePageTracking = (path) => {
  useEffect(() => {
    track("page_view", { path, referrer: document.referrer });
  }, [path]);
};

export const useSectionTracking = (sectionId, ref) => {
  const tracked = useRef(false);

  useEffect(() => {
    if (!ref?.current || tracked.current) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !tracked.current) {
          tracked.current = true;
          track("section_view", { section: sectionId, path: window.location.pathname });
        }
      },
      { threshold: 0.3 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [sectionId, ref]);
};

export const trackBlogRead = (blogId) => {
  track("blog_read", { blog_id: blogId, path: `/blog/${blogId}` });
};
